import React from "react";
import { useDrag, useDrop } from "react-dnd";
import { XIcon } from "lucide-react";

interface DropDown {
  image: string;
  name: string;
  quantity: number;
  productId: number;
}
interface ProductItemProps {
  product: DropDown;
  index: number;
  moveProduct: (dragIndex: number, hoverIndex: number) => void;
  removeProduct: (product: DropDown, e: React.MouseEvent) => void;
}

const ProductItem: React.FC<ProductItemProps> = ({
  product,
  index,
  moveProduct,
  removeProduct,
}) => {
  const [, ref] = useDrag({
    type: "product",
    item: { index },
  });

  const [, drop] = useDrop({
    accept: "product",
    hover(item: { index: number }) {
      if (item.index !== index) {
        moveProduct(item.index, index);
        item.index = index;
      }
    },
  });

  return (
    <div
      ref={(node) => ref(drop(node))}
      className="relative flex flex-col items-center bg-white border-2 border-customGreenColor/20 hover:border-customGreenColor p-3 rounded-lg cursor-move w-32 transition-all duration-200 hover:shadow-md"
    >
      <div className="absolute top-2 left-2 flex items-center justify-center w-6 h-6 bg-customGreenColor text-white rounded-full text-xs font-medium">
        {index + 1}
      </div>
      <XIcon
        className="absolute top-2 right-2 w-5 h-5 text-gray-400 hover:text-red-500 cursor-pointer transition-colors"
        onClick={(e) => removeProduct(product, e)}
      />
      <img
        src={product.image}
        alt={product.name}
        className="w-20 h-20 object-cover rounded-md my-2 mt-8"
      />
      <span className="text-center text-sm font-medium line-clamp-2 w-full mt-2">
        {product.name}
      </span>
    </div>
  );
};

export default ProductItem;
